import {
    FLOW_STEP_BILLING,
    FLOW_STEP_NUMBERS,
    FLOW_STEP_PLANS,
    PATH_PLANS,
    PATH_TRIAL_NUMBERS,
    PATH_TRIAL_SIGNUP
} from '~/common/utils/consts.js';
import { Link, Redirect, withRouter } from 'react-router-dom';
// Import Dependencies
import React, { Component, Fragment } from 'react';
import { createPersonalizedPurchaseEvent, scBeacon, gtm, viewContentEvent, clickCtaEvent } from '~/common/utils/tracking.js';
import { inject, observer } from 'mobx-react';

import Centering from '~/common/components/Centering';
import HeaderGroup from '~/common/components/HeaderGroup';
import InfoIcon from '~/common/components/InfoIcon2';
import Stepper from '~/common/components/Stepper';
import Tooltip from '~/common/components/Tooltip';
import Button from '~/common/components/CommonButton';
import TrialNumbers from '~/views/TrialSignup/components/TrialNumbers';
import TrialSignupForm from '~/views/TrialSignup/components/TrialSignupForm';
import includes from 'lodash/includes';
import { isTouchDevice } from '~/common/utils/deviceDetection.js';
import { premiumAreaCodes } from '~/common/utils/premiumAreaCodes.js';
// Import images
import productLaptopPhone from '~/common/images/trial-signup-img.png';
import checkIcon from '~/common/images/gh-check-smooth-icon.svg';
// Import Local Styles
import styles from './trial-signup.css';

const IS_TOUCH_DEVICE = isTouchDevice();

@withRouter
@inject('lockNumberStore', 'modalStore', 'trialSignupStore', 'progressStore')
@observer
export default class TrialSignup extends Component {
    componentDidMount() {
        document.querySelector('meta[name="description"]').content = "Sign up for your free trial of Grasshopper, no credit card required. Learn more about what's included in the 7-day trial today!";
        document.title = 'Grasshopper Free Trial | Try Free for 7 Days';
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        const { lockNumberStore, modalStore, trialSignupStore, progressStore, history } = this.props;
        // since this is a trial view, the plan is preselected
        if (!progressStore.firstView) progressStore.setFirstView(FLOW_STEP_PLANS);
        // if trial flow is not set set it
        if (!trialSignupStore.isTrialFlow) trialSignupStore.setIsTrialFlow(true);

        // TrialSignup is a wrapper for both the Trial Numbers view and the Trial Signup Form view
        const isNumbersStep = includes(history?.location?.pathname, PATH_TRIAL_NUMBERS);
        if (isNumbersStep) {
            gtm(viewContentEvent('trial flow', 'numbers', 'numbers'));
        }

        // track SCBeacon: saw Numbers page first or after picking a plan
        if (!lockNumberStore.selectedNumberUI) scBeacon(createPersonalizedPurchaseEvent('0'));
        // if number is  preselected from marketing site and it is a premium number
        if (lockNumberStore.isNumberPreselected && lockNumberStore.isSelectedAreaCodePremium) {
            // open premium modal
            modalStore.setModalOptions({
                childComponentString: 'upgradeModal',
                isModalClosable: true,
                modalType: 'xlarge',
                isModalOpen: true
            });
        }
    }

    goToBuyFlow() {
        const { history, trialSignupStore } = this.props;
        trialSignupStore.setIsTrialFlow(false);
        // Track Buy Now CTA
        gtm(clickCtaEvent('buy now', PATH_PLANS, 'trial signup'));
        history.push(PATH_PLANS);
    }

    render() {
        const { history, lockNumberStore } = this.props;
        // TrialSignup is a wrapper for both the Trial Numbers view and the Trial Signup Form view
        const isNumbersStep = includes(history.location.pathname, PATH_TRIAL_NUMBERS);
        // if number is preselected, and it is not premium, and it is locked to the session and you are on the numbers view, redirect to the sign up form
        if (lockNumberStore.isNumberPreselected && !lockNumberStore.isSelectedAreaCodePremium && lockNumberStore.numberIsLocked && isNumbersStep) return <Redirect to={PATH_TRIAL_SIGNUP} />;
        const { localUS, localCanada, tollFree } = premiumAreaCodes;

        const isFreeTrialFlowLocked = false;

        return (
            <div className={styles['trial-signup']}>
                <Centering relative={true}>
                    {
                        isFreeTrialFlowLocked
                            ? <h1 className={styles['unavailable-flow']}>Free Trial is not available at the moment. Please try it later! or signup for a Paid account <Link to={PATH_PLANS}>here.</Link></h1>
                            : <Fragment>
                                <Stepper currentStep={isNumbersStep ? FLOW_STEP_NUMBERS : FLOW_STEP_BILLING} />
                                <HeaderGroup>
                                    <h1>Start your free 7-day trial now!</h1>
                                    <h2>No credit card. No commitment. Try Grasshopper, on us.</h2>
                                </HeaderGroup>
                                <div className={styles.wrapper}>
                                    <div className={styles['wrapper-col']}>
                                        <img
                                            alt="product laptop phone"
                                            className={styles.image}
                                            src={productLaptopPhone}
                                        />
                                        <div className={styles['details-wrapper']}>
                                            <h3 className={styles.subheader}>What’s included in the 7-day trial:</h3>
                                            <div className={styles.details}>
                                                <div className={styles['icon-wrapper']}>
                                                    <img className={styles['detail-check-icon']} src={checkIcon}></img>
                                                    <div className={styles.text}>
                                                        1 Phone Number
                                                        <Tooltip
                                                            activeTriggerModifiers={styles['tooltip-trigger--active']}
                                                            content={
                                                                <div>
                                                                    <p>
                                                                        Does not include premium numbers: numbers with the following area codes. <strong>US Local:</strong> {localUS.join(', ')}. <strong>Toll free:</strong> {tollFree.join(', ')}. <strong>Canada:</strong> {localCanada.join(', ')}.
                                                                    </p>
                                                                    <p>
                                                                        To get a premium number, you can skip the trial and&#160;
                                                                        <Button
                                                                            modifier={styles['text-link']} onClick={() => this.goToBuyFlow()}
                                                                            tertiary
                                                                        >buy now.</Button>
                                                                    </p>
                                                                </div>
                                                            }
                                                            direction="left"
                                                            triggerModifiers={styles['tooltip-trigger']}
                                                        >
                                                            <InfoIcon
                                                                modifier={`${
                                                                    styles['info-icon']} ${
                                                                    IS_TOUCH_DEVICE ? styles['info-icon--touch-device'] : ''
                                                                }`}
                                                            />
                                                        </Tooltip>, and 3 Extensions
                                                    </div>
                                                </div>
                                                <div className={styles['icon-wrapper']}>
                                                    <img className={styles['detail-check-icon']} src={checkIcon}></img>
                                                    <p className={styles.text}>50 Business Talk Minutes</p>
                                                </div>
                                                {/* ESC-893 */}
                                                {/* <div className={styles['icon-wrapper']}>
                                                    <img className={styles['detail-check-icon']} src={checkIcon}></img>
                                                    <p className={styles.text}>100 Business Texts
                                                        <Tooltip
                                                            activeTriggerModifiers={styles['tooltip-trigger--active']}
                                                            content={
                                                                <div>
                                                                    <p>
                                                                        <span>Due to industry compliance requirements, registration required for toll-free numbers before sending text messages.</span> <a href='https://support.grasshopper.com/help/register-your-phone-numbers-for-sms-compliance' target='_blank'>Click here to learn more.</a>
                                                                    </p>
                                                                </div>
                                                            }
                                                            direction="left"
                                                            triggerModifiers={styles['tooltip-trigger']}
                                                        >
                                                            <InfoIcon
                                                                modifier={`${
                                                                    styles['info-icon']} ${
                                                                    styles['info-icon--margin-right']} ${
                                                                    IS_TOUCH_DEVICE ? styles['info-icon--touch-device'] : ''
                                                                }`}
                                                            />
                                                        </Tooltip>
                                                    </p>
                                                </div> */}
                                                <div className={styles['icon-wrapper']}>
                                                    <img className={styles['detail-check-icon']} src={checkIcon}></img>
                                                    <p className={styles.text}>All the same features you get with the full version of Grasshopper!</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles['details-wrapper']}>
                                            <h3 className={styles.subheader}>What's not included: </h3>
                                            <ul className={styles['details-list']}>
                                                <li className={styles['details-list-item']}>Premium numbers</li>
                                                <li className={styles['details-list-item']}>Text messaging. Industry mandated SMS registration must be completed to send text messages, and requires a paid Grasshopper plan.</li>
                                                <li className={styles['details-list-item']}>If you’re looking for a premium number, unlimited minutes, or texting you can skip the trial and
                                                    <Button
                                                        modifier={styles['text-link']} onClick={() => this.goToBuyFlow()}
                                                        tertiary
                                                    >
                                                        buy now.
                                                    </Button>
                                                </li>
                                            </ul>
                                            {/* ESC-893 */}
                                            {/* Premium numbers
                                            <Tooltip
                                                activeTriggerModifiers={styles['tooltip-trigger--active']}
                                                content={
                                                    <div>
                                                        <p>
                                                            Premium numbers include numbers with the following area codes. <strong>US Local:</strong> {localUS.join(', ')}. <strong>Toll free:</strong> {tollFree.join(', ')}. <strong>Canada:</strong> {localCanada.join(', ')}.
                                                        </p>
                                                    </div>
                                                }
                                                direction="left"
                                                triggerModifiers={styles['tooltip-trigger']}
                                            >
                                                <InfoIcon
                                                    modifier={`${
                                                        styles['info-icon']} ${
                                                        styles['info-icon--margin-right']} ${
                                                        IS_TOUCH_DEVICE ? styles['info-icon--touch-device'] : ''
                                                    }`}
                                                />
                                            </Tooltip>. If you're looking for a premium number, or you need unlimited minutes and texting, you can skip the trial and&#160;
                                            <Button
                                                modifier={styles['text-link']} onClick={() => this.goToBuyFlow()}
                                                tertiary
                                            >buy now.</Button> */}
                                        </div>
                                    </div>
                                    <div className={styles['wrapper-col']}>
                                        {isNumbersStep ?
                                            <TrialNumbers />
                                            :
                                            <TrialSignupForm />
                                        }
                                    </div>
                                </div>
                            </Fragment>
                    }
                </Centering>
            </div>
        );
    }
}
